<template lang="pug">
	.busca__resultado__wrapper
		.busca__resultado__inner
			h1.busca__resultado__title Resultado da busca.
			h2.busca__resultado__subtitle Encontramos {{this.find.length}} resultado(s) para sua busca.
			.busca__resultado__list
				a(:href="item.url", target="_blank", v-for="item in this.find.slice(0, this.count)").busca__resultado__list_item
					.busca__resultado__list_item_title {{item.title}}
					.busca__resultado__list_item_description {{item.url}}
					a(:href="item.url_2", target="_blank" style="text-decoration: auto;").busca__resultado__list_item_description(v-if="item.url_2") {{item.url_2}}
					.busca__resultado__list_item_description(v-if="item.text") {{item.text}}
			.busca__more(v-if="this.count < this.find.length")
				button.button(@click="more_results") Ver mais
</template>

<script>
import Search_Index from "@/assets/search_index.json";

export default {
	name: "Busca",
	data: function() {
		return {
			count: 5
		}
	},
	computed: {
		find() {
			const terms = this.normalize(this.initial_term_value).split(' ').filter(f => { return f.length > 3; });

			const result = [];

			if (terms.length > 0) {
				terms.forEach(term => {
					if (Object.keys(Search_Index).indexOf(term) > -1) {
						Search_Index[term].forEach(item => {
							result.push(item);
						})
					}	
				});
			}
			
			return result;
		},
		initial_term_value: function() {
			if (this.$route.params) {
				if (this.$route.params.term) {
					return this.$route.params.term;
				}
			}

			return "";
		}
	},
	methods: {
		normalize: function(text) {
			return text.toLowerCase().replace(/&/gi, '').replace(/\(/gi, '').replace(/\)/gi, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\?/gi, '').replace(/:/gi, '');
		},
		more_results: function() {
			this.count = this.count + 5;
		}
	}
}
</script>